import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';
import { theme } from '@pairy/styles';

export const FlexWrapper = styled(Flex)`
  width: 100vw;
  height: 100vh;
  background-color: ${theme.colors.zinc_50};
`;
